// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"Date-module--wrapper--1EqsX","dash":"Date-module--dash--KfY0W"};